import Hero from '../../components/Hero/Hero'
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs"
import visualizador from "../../assets/img/icono-visualizador.png"
import SearchAndFilter from './components/SearchAndFilters/SearchAndFilter'
import IndicatorMapper from '../../components/Mappers/IndicatorMapper'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { useEffect, useRef, useState } from 'react'
import { getIndicators, GetIndicatorsQuery } from '../../redux/slices/indicatorDisplay/indicator/indicatorThunk'
import { useLocation, useNavigate } from 'react-router-dom'
import SEO from '../../components/SEO/SEO'
import { clearIndicators } from '../../redux/slices/indicatorDisplay/indicator/indicatorSlice'
import Loading from '../../components/Loading/Loading'
import Pagination from '../../components/Pagination/Pagination'
import { sendAnalyticsEvent } from '../../FirebaseConfig'
import useIsMobile from '../../hooks/useIsMobile'
import { evaluationSubDimension, selectedDimension } from '../../redux/slices/evaluator/evaluatorSlice'
import TipBanner from '../../components/Cards/TipBanner'
import { INDICATOR_TYPE_STRUCTURAL, SEARCH_MODE_EXPANDED, SEARCH_MODE_PREDICTIVE } from '../../utils/const'
import ResponsiveContainer from '../../layouts/ResponsiveContainer'
import { useMobileBanner } from '../../hooks/useMobileBanner'
import useUrlParams from '../../hooks/useUrlParams'
import ContactSection from '../../components/Common/ContactSection'

//Informacion para volver a secciones
interface Previous {
    path: string;
    right: string;
    rightId: string;
    period: string;
    indicatorTypes: string;
    indicatorTypesId: string;
    dimension: string;
    dimensionId: string;
}

const PATH_EVALUADOR = '/evaluador';

const Index = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { getMultipleParams } = useUrlParams();

    const params = new URLSearchParams(location.search);
    const previous: Previous = JSON.parse(sessionStorage.getItem("previous") || "{}");

    const { indicators, pagination, loading } = useAppSelector((state) => state.indicator)
    const { currentPage, totalPages } = pagination;
    const { lastPeriod } = useAppSelector((state) => state.periods);

    const [showButtonGoBack, setShowButtonGoBack] = useState(false);

    const isMobile = useIsMobile();
    const { showBanner, closeBanner } = useMobileBanner();

    const message = previous.indicatorTypes === INDICATOR_TYPE_STRUCTURAL
        ? "No se encontraron indicadores evaluados."
        : "No se encontraron indicadores.";

    const initialLoadDone = useRef(false);
    // Este useEffect solo se ejecuta cuando indicators.length es 0, es decir, en la carga inicial.
    useEffect(() => {
        if (initialLoadDone.current) return;
        if (loading === 'pending') return;

        const right = getMultipleParams('rightId') || '';  
        const period = params.get('period') || '';

        if (!period) return;

        const indicators: string[] = getMultipleParams('indicatorID');
        const indicatorTypes = getMultipleParams('type') || '';
        const dimension = getMultipleParams('dimensionID');
        const subdimension = getMultipleParams('subdimensionID');
        const odsIDs = getMultipleParams('odsID');
        const priorityGroups = getMultipleParams("priorityGroups");
        const page = parseInt(params.get('page') || '1', 10);
        const limit = parseInt(params.get('limit') || '5', 10);
        const endPeriod = parseInt(params.get('period') || '5', 10);
        const searchMode = params.get("searchMode");
        const filterApplied = params.get("filterApplied");

        const query: GetIndicatorsQuery = {
            rightsId: right,
            page,
            limit,
            endPeriod,
        };

        if (searchMode === SEARCH_MODE_PREDICTIVE && filterApplied !== 'true') {
            if (indicatorTypes.find((i) => i.includes(INDICATOR_TYPE_STRUCTURAL))) {
                query.indicatorIds = indicators;
                query.indicatorsType = indicatorTypes;
            } else {
                if (indicatorTypes) query.indicatorsType = indicatorTypes;
                if (dimension.length > 0) query.dimension = dimension;
                if (subdimension.length > 0) query.subdimension = subdimension;
                if (indicators.length > 0) query.indicatorIds = indicators;
            }
        } else {
            if (indicatorTypes) query.indicatorsType = indicatorTypes;
            if (dimension.length > 0) query.dimension = dimension;
            if (subdimension.length > 0) query.subdimension = subdimension;
            if (indicators.length > 0) query.indicatorIds = indicators;
            if (odsIDs.length > 0) query.ods = odsIDs;
            if (priorityGroups.length > 0) query.priorityGroups = priorityGroups;
            if (right) query.rightsId = right;
            if (searchMode === SEARCH_MODE_EXPANDED) query.search = params.get("search") || '';
        }

        initialLoadDone.current = true;
        dispatch(getIndicators(query));
    }, [location.search, loading]);

    useEffect(() => {
        //Revisar esto --
        const indicatorID = params.get('indicatorID') || '';
        const indicator = params.get('indicator')
        if (indicator && indicatorID) {
            sendAnalyticsEvent("viewed_indicator",
                {
                    indicator_name: indicator.replaceAll('+', ' ').trim()
                });
        }
    }, [location.search, params]);

    useEffect(() => {
        return () => {
            dispatch(clearIndicators());
            initialLoadDone.current = false;
        }
    }, [])

    useEffect(() => {
        if (Object.keys(previous).length > 0) {
            setShowButtonGoBack(true);
        } else {
            setShowButtonGoBack(false);
        }
    }, []);

    const handleClose = () => {
        closeBanner();
        sessionStorage.setItem("tipBannerClosed", "true");
    };

    const handlePageChange = (page: number) => {
        const params = new URLSearchParams(location.search);
        params.set('page', page.toString());
        navigate({ search: params.toString() });
        dispatch(getIndicators({
            rightsId: getMultipleParams('rightId') || [],
            subdimension: getMultipleParams('subdimensionID') || [],
            dimension: getMultipleParams('dimensionID') || [],
            indicatorsType: getMultipleParams('type') || '',
            ods: getMultipleParams('odsID') || [],
            priorityGroups: getMultipleParams("priorityGroups"),
            page,
            limit: parseInt(params.get('limit') || '5', 10),
            endPeriod: parseInt(params.get('period') || '5', 10),
            search: params.get('search') || '',
        }));
    };

    const handleOnClickGoBack = () => {
        if (previous.path !== PATH_EVALUADOR) return;
        dispatch(selectedDimension({ dimension: { name: previous.dimension, id: Number(previous.dimensionId) } }));
        dispatch(evaluationSubDimension({ dimensionId: Number(previous.dimensionId) }));
    };

    return (
        <>
            <SEO
                title='Visualizador de indicadores'
                description='Visualizador de indicadores'
                type='website'
            />
            <Hero
                breadcrumbs={<Breadcrumbs />}
                title={"Visualizador de indicadores"}
                paragraph={"Nuestro visualizador está diseñado para que puedas sumergirte en el detalle de cada uno de los indicadores que monitoreamos y las variables que los componen.  A través de distintos formatos, contribuye a la transparencia de los datos oficiales y te brinda la posibilidad de conocer con más profundidad la situación de los derechos en la Ciudad Autónoma de Buenos Aires."}
                layout="row"
                media={{
                    type: 'image',
                    src: visualizador,
                    url: '',
                    alt: 'visualizador',
                    className: 'hidden lg:inline lg:w-[304px] lg:h-[172px] xl:w-[360px] xl:h-[204px] object-contain xl:object-cover'
                }}
                buttonGoBack={showButtonGoBack}
                handleOnClickGoBack={handleOnClickGoBack}
                expandableDescription={isMobile ? true : false}
                buttonExpandableDescriptionClassName="md:hidden"
                containerHeightClassName='h-[36rem] sm:h-[30rem]'
                titleClassName='text-brand-green-20'
                backgroundClassName={{ backgroundColor: '#E3DDD8' }}
            />
            <div className='relative mt-10 flex justify-center items-center flex-col'>
                <SearchAndFilter />
                <ResponsiveContainer className='h-full' id='indicator-cards'>
                    <p className="text-primary-10 mt-10 font-medium">
                        Indicadores encontrados: <span className='font-normal'>{loading === 'pending' ? 0 : pagination.totalItems}</span>
                    </p>
                    {
                        loading === 'pending'
                            ? <Loading
                                size={40}
                                className='h-[300px]'
                            />
                            : (<>
                                {
                                    indicators && indicators?.length > 0 ? (
                                        <div className='relative'>
                                            <TipBanner
                                                handleClose={handleClose}
                                                isOpen={showBanner}
                                            />
                                            <IndicatorMapper
                                                indicators={indicators ? indicators : []}
                                                period={Number(lastPeriod?.value)}
                                            />
                                            <Pagination
                                                data={indicators || []}
                                                totalPages={totalPages}
                                                currentPage={currentPage}
                                                setCurrentPage={handlePageChange}
                                                scrollTargetId='indicator-cards'
                                            />
                                        </div>
                                    ) : (
                                        <div className="text-center mt-8">
                                            {message}
                                        </div>
                                    )}
                            </>
                            )}
                </ResponsiveContainer>
            </div>
            <ContactSection />
        </>
    )
}

export default Index